import { useStore } from './store';

const getBackendUrl = () => useStore.getState().settings.backendUrl;

// DeepSeek API 改写提示词
export async function rewritePrompt(input: string): Promise<any> {
  const response = await fetch(`${getBackendUrl()}/api/rewrite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ input }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '改写失败');
  }

  return response.json();
}

// 提交视频生成任务
export async function submitTask(params: {
  prompt: string;
  duration?: number;
  aspectRatio?: string;
  model_version?: string;
}): Promise<{ taskId: string; status: string }> {
  const response = await fetch(`${getBackendUrl()}/api/submit`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '提交失败');
  }

  return response.json();
}

// 查询任务状态
export async function getTaskStatus(taskId: string): Promise<any> {
  const response = await fetch(`${getBackendUrl()}/api/status/${taskId}`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '查询失败');
  }

  return response.json();
}

// SSE 实时进度
export function subscribeTaskProgress(
  taskId: string,
  onProgress: (data: any) => void,
  onError: (error: Error) => void
): () => void {
  const url = `${getBackendUrl()}/api/status/${taskId}/stream`;
  const eventSource = new EventSource(url);

  eventSource.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      onProgress(data);
      if (data.status === 'completed' || data.status === 'failed') {
        eventSource.close();
      }
    } catch (e) {
      console.error('SSE parse error:', e);
    }
  };

  eventSource.onerror = () => {
    onError(new Error('连接中断'));
    eventSource.close();
  };

  return () => eventSource.close();
}

// 查询积分
export async function getCredits(): Promise<{ credits: number }> {
  const response = await fetch(`${getBackendUrl()}/api/credits`);

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '查询积分失败');
  }

  return response.json();
}

// 批量提交
export async function submitBatch(params: {
  tasks: Array<{
    prompt: string;
    duration?: number;
    aspectRatio?: string;
    model_version?: string;
  }>;
}): Promise<{ batchId: string; tasks: Array<{ taskId: string }> }> {
  const response = await fetch(`${getBackendUrl()}/api/submit-batch`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '批量提交失败');
  }

  return response.json();
}

// 批量任务生成（AI规划）
export async function prepareBatchTasks(input: string): Promise<{
  batchName: string;
  description: string;
  tasks: any[];
}> {
  const response = await fetch(`${getBackendUrl()}/api/rewrite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ input, mode: 'batch' }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || '批量任务生成失败');
  }

  return response.json();
}